module.exports = __webpack_public_path__ + "img/google.b5459330.png";